//
// Copyright (c) 2019-Present Syncari - All rights reserved.
//
import cx from 'classnames';
import * as React from 'react';

import { ReactComponent as StepActiveIcon } from 'assets/images/step-active.svg';
import { ReactComponent as StepCompletedIcon } from 'assets/images/step-completed.svg';
import { ReactComponent as StepInactiveIcon } from 'assets/images/step-inactive.svg';

import './InsightsWizardSteps.less';

type StepState = 'active' | 'completed' | 'inactive';

const STEP_ICONS: Record<StepState, React.FC<React.SVGProps<SVGSVGElement>>> = {
  active: StepActiveIcon,
  completed: StepCompletedIcon,
  inactive: StepInactiveIcon,
};

const StepIcon = ({ state }: { state: StepState }) => {
  const Icon = STEP_ICONS[state];
  return <Icon />;
};

export interface InsightsWizardStepsProps {
  steps: string[];
  currentStep: number;
  onStepClick?: (index: number) => void;
}

export const InsightsWizardSteps = ({ steps, currentStep, onStepClick }: InsightsWizardStepsProps) => (
  <div className="insights-wizard-steps">
    {steps.map((label, index) => {
      const state: StepState = currentStep === index ? 'active' : index < currentStep ? 'completed' : 'inactive';
      return (
        <div
          key={index}
          className={cx('insights-wizard-steps__item', {
            'insights-wizard-steps__item--clickable': !!onStepClick,
          })}
          onClick={onStepClick ? () => onStepClick(index) : undefined}>
          <div className="insights-wizard-steps__indicator-col">
            <StepIcon state={state} />
            {index < steps.length - 1 && (
              <div
                className={cx('insights-wizard-steps__connector', {
                  'insights-wizard-steps__connector--completed': index < currentStep,
                })}
              />
            )}
          </div>
          <div className="insights-wizard-steps__label-wrap">
            <span
              className={cx('insights-wizard-steps__label', {
                'insights-wizard-steps__label--active': state === 'active',
              })}>
              {label}
            </span>
          </div>
        </div>
      );
    })}
  </div>
);

export default InsightsWizardSteps;
